module.exports = __webpack_public_path__ + "static/media/icn-adjusters.a0a869a2.svg";